export enum RecordingStatusEnum {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  REVIEW = 'review',
  STASHED = 'stashed',
  DECLINED = 'declined',
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
}

export enum RecordingActionSuccessTypeEnum {
  RECORDING_MOVED,
  RECORDING_SHARED,
  RECORDING_CLONED,
  RECORDING_REMOVED,
  RECORDING_BATCH_MOVE,
  RECORDING_BATCH_REMOVE,
}
